export default __webpack_public_path__ + "static/media/640_dummy2016-immobilien01-de.a42c6435.png";